import { useLang } from '../lang'
import type { Tally } from '../types'
import { Kicker } from '../design'
import * as l from './lists.css'

// The roll of birds: bilingual name, freshest first, one line of meta each. Shared by Live's
// "Recently heard" (meta = time-ago, a moving window) and the Journal's "Heard this day" (meta =
// the clock time it was last heard, a finished day). One component so the two tenses of the same
// section can never drift apart — the caller supplies only the heading and how to say *when*.
export function HeardList({
  title,
  heard,
  meta,
  onSelect,
}: {
  title: string
  heard: Tally[]
  meta: (t: Tally) => string
  onSelect: (sci: string) => void
}) {
  const { lang } = useLang()
  const other = lang === 'ga' ? 'en' : 'ga'
  const primary = (en: string, ga: string | null) => (lang === 'ga' && ga ? ga : en)
  // The other language only when there IS one and it differs from what is already shown — a bird
  // with no Irish name must not read "Storm Petrel Storm Petrel".
  const secondary = (en: string, ga: string | null) => {
    const first = primary(en, ga)
    const second = lang === 'ga' ? en : ga
    return second && second !== first ? second : null
  }

  if (!heard.length) return null

  return (
    <section className={l.recent}>
      <Kicker as="h2" className={l.tag}>
        {title}
      </Kicker>
      <ul className={l.list}>
        {heard.map((r) => {
          const gloss = secondary(r.en, r.ga)
          return (
            <li key={r.sci}>
              <button type="button" className={l.row} onClick={() => onSelect(r.sci)}>
                <span className={l.rowName}>
                  {primary(r.en, r.ga)}
                  {gloss && (
                    <em lang={other} className={l.rowGloss}>
                      {gloss}
                    </em>
                  )}
                </span>
                <span className={l.rowMeta}>{meta(r)}</span>
              </button>
            </li>
          )
        })}
      </ul>
    </section>
  )
}
